import { SVGAttributes } from 'react'
import { ReactComponent as SearchSvg } from '_icons/ui/search.svg'

export const AppSearchIcon = (props: SVGAttributes<SVGSVGElement>) => {
  return (
    <SearchSvg {...props} className={'MuiSvgIcon-root ' + props.className} />
  )
}
